export enum LoggerTypeEnum {
    DEBUG = 0,
    INFO = 1,
    WARN = 2,
    ERROR = 3,

    NONE = 10,
}
